import { http } from "..";

export const getRewards = () => {
  return http.get("/rewards/get-rewards");
};
